import { Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, Step, StepLabel, Stepper, TextField, Typography, Card } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { campaignApi } from "../../api/campaignApi";
import toast from 'react-hot-toast';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import * as React from 'react';
import { alpha } from '@mui/material/styles';
import { getTone, lightVeil, grey } from '../../theme/tones';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DialogRetrieve = (propsData) => {
  const theme = useTheme();
  const { initialValues, validationSchema, setIsLoading, idCampaign, qualifications, isLoading, selectedStatusRetrieve, selectedCommercialRetrieve,
    openRetrieve, setOpenRetrieve, activeStepRetrieve, stepsRetrieve, setSelectedStatusRetrieve, handleBackRetrieve, handleNextRetrieve
  } = propsData;

  return (
    <Dialog
      open={openRetrieve}
      onClose={() => setOpenRetrieve(false)}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: '20px', p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Paramètres du rattrapage</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              setIsLoading(true);
              await campaignApi.retrieveCustomers(idCampaign, selectedStatusRetrieve, selectedCommercialRetrieve, localStorage.getItem('accessToken'));
              setStatus({ success: true });
              setSubmitting(false);
              toast.success('Rattrapage effectué avec succès');
              setOpenRetrieve(false);
              setIsLoading(false);
              window.location.reload(false);
            } catch (err) {
              console.error(err);
              toast.error('Il y a eu un souci lors du rattrapage !');
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
              setIsLoading(false);
            }
          }}
        >
          {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Stepper
                activeStep={activeStepRetrieve}
                sx={{
                  mb: 4,
                  mt: 2,
                  '& .MuiStepLabel-label': { fontWeight: 600 },
                  '& .MuiStepIcon-root.Mui-active': { color: 'primary.main' },
                  '& .MuiStepIcon-root.Mui-completed': { color: 'success.main' }
                }}
              >
                {stepsRetrieve.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>

              <Box sx={{ minHeight: 120 }}>
                {activeStepRetrieve === 0 && (
                  <Grid container>
                    <Grid item xs={12} md={8}>
                      <Autocomplete
                        multiple
                        id="checkboxes-tags-statuts-retrieve"
                        options={qualifications || []}
                        value={selectedStatusRetrieve}
                        disableCloseOnSelect
                        onChange={(event, newValue) => {
                          setSelectedStatusRetrieve([...newValue]);
                        }}
                        getOptionLabel={(option) => option.qualification}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.qualification}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Statuts"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              sx: { borderRadius: '12px' }
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                )}

                {activeStepRetrieve === 1 && (
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: theme.palette.text.primary }}>
                      Récapitulatif du rattrapage
                    </Typography>

                    <Card
                      variant="outlined"
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        borderColor: theme.palette.divider,
                        backgroundColor: theme.palette.mode === 'light' ? grey(50) : lightVeil(0.01)
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: theme.palette.text.secondary }}>
                        Statuts ciblés pour le rattrapage :
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
                        {selectedStatusRetrieve.length > 0 ? (
                          selectedStatusRetrieve.map((status) => (
                            <Box
                              key={status.qualification}
                              sx={{
                                py: 0.5,
                                px: 1.5,
                                borderRadius: '8px',
                                backgroundColor: theme.palette.mode === 'light' ? grey(0) : lightVeil(0.05),
                                border: '1px solid',
                                borderColor: 'divider',
                                fontSize: '0.825rem',
                                fontWeight: 600
                              }}
                            >
                              {status.qualification}
                            </Box>
                          ))
                        ) : (
                          <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                            Tous statuts
                          </Typography>
                        )}
                      </Box>
                    </Card>
                  </Box>
                )}
              </Box>

              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 3, pb: 1, gap: 1.5 }}>
                <Button
                  color="inherit"
                  disabled={activeStepRetrieve === 0}
                  onClick={handleBackRetrieve}
                  variant="outlined"
                  sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, borderColor: 'divider' }}
                >
                  Précédent
                </Button>
                <Box sx={{ flex: '1 1 auto' }} />
                {activeStepRetrieve !== 1 ? (
                  <Button
                    onClick={handleNextRetrieve}
                    variant="contained"
                    sx={{
                      background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                      color: grey(0),
                      borderRadius: '10px',
                      px: 3,
                      textTransform: 'none',
                      fontWeight: 600,
                      boxShadow: (theme) => `0 4px 12px 0 ${alpha(theme.palette.secondary.main, 0.25)}`,
                      '&:hover': {
                        background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.dark} 100%)`
                      }
                    }}
                  >
                    {activeStepRetrieve === stepsRetrieve.length - 1 ? 'Passer au récapitulatif' : 'Suivant'}
                  </Button>
                ) : (
                  <Button
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    variant="contained"
                    sx={{
                      background: (theme) => `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.main} 100%)`,
                      color: grey(0),
                      borderRadius: '10px',
                      px: 3,
                      textTransform: 'none',
                      fontWeight: 600,
                      boxShadow: (theme) => `0 4px 12px 0 ${alpha(theme.palette.success.main, 0.25)}`,
                      '&:hover': {
                        background: `linear-gradient(135deg, ${getTone('emerald').color} 0%, ${getTone('emerald').color} 100%)`
                      }
                    }}
                  >
                    Enregistrer
                  </Button>
                )}
                {isLoading && (
                  <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    <CircularProgress size={24} />
                  </Box>
                )}
              </Box>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default DialogRetrieve;
